const SVGAnimate = () => {
    const animateList = { 
        "rotate": ["#pie03", "#doughnut02", "#Group_9" ],
        "rotate-inverse": ["#doughnut01"],
        "zoom": ["#pie01","#pie02","#pie04"],
        "pulse": ["#ellipse"],
        //"stargate": ["#Subtract"]
    }
    for (let currentClass in animateList) {
        const elements = animateList[currentClass];
        /* eslint-disable */
        elements.map(key => {
            const elem = document.querySelector(key);
            if (elem && elem.classList) {
                elem.classList.add(currentClass)
            }
        })
    }
    //Left
    document.querySelectorAll("#left-bars").forEach(elem => {
        const percent = Math.random() * 50;
        elem.style.setProperty('--animation-time', percent + '%');
        elem.classList.add("resize-left")
    })

    //Right
    document.querySelectorAll("#right-bars").forEach(elem => {
        const percent = Math.random() * 50;
        elem.style.setProperty('--animation-time', percent + '%');
        elem.classList.add("resize-right")
    })
}

export default SVGAnimate